export default __webpack_public_path__ + "static/media/expl-nn_12_DE.ebad159d.png";